import styled from "styled-components";
import avanegarBg from "../../assets/images/avanegar-bg.svg";

export const UsageContainer = styled.section`
  /* width: 100%; */
  height: 432px;
  display: flex;
  background: url(${avanegarBg}) no-repeat right center,
    linear-gradient(#12a46fc2, rgba(18, 164, 111, 0.76));
  margin-bottom: 11rem;
  align-items: center;
  @media (max-width: 600px) {
    height: 767px;
    width: 100%;
    /* padding: 4rem 0; */
    background-image: url(${avanegarBg});
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4rem;
  }
  @media (max-width: 480px) {
    height: 617px;
  }
`;
export const UsagesWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-top: 10rem; */
  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 4rem;
  }
`;
export const UsageListContainer = styled.ul`
  width: 33%;
  margin-right: 10%;
  z-index: 50;
  @media (max-width: 1024px) {
    margin-right: 10px;
    width: 45%;
  }
  @media (max-width: 600px) {
    height: 240px;
    width: 468px;
  }
  @media (max-width: 580px) {
    width: 100%;
  }
  li {
    font-size: 2.4rem;
    font-weight: 400;
    color: var(--white-color);
    font-family: Peyda;
    line-height: 4.8rem;
    list-style: disc;
    @media (max-width: 600px) {
      font-size: 1.6rem;
    }
  }
`;

export const UsagesImgContainer = styled.div`
  width: 50%;
  img {
    width: 100%;
    display: block;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: 168px;
  margin-top: 1.2rem;

  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 3.2rem;
    line-height: 5.6rem;
    color: var(--white-color);
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width1024 || "100%"};
    height: ${(props) => props.height};
    p {
      font-size: 2.6rem;
    }
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "468px"};
    height: auto;
    margin-bottom: 2.4rem;
    p {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width600 || "100%"};
  }
`;

export const TitleContainer = styled.div`
  width: ${(props) => props.width || "23%"};
  position: relative;
  @media (max-width: 1024px) {
    width: 35%;
  }
  @media (max-width: 680px) {
    width: 45%;
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "100%"};
  }
  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: ${(props) => props.titleColor || "#FFFFFF"};
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 0.6rem;
    font-family: Peyda;
  }
  p {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.3rem;
    padding-right: 1.4rem;
    color: ${(props) => props.textColor || "#FFFFFF"};
    @media (max-width: 1024px) {
      font-size: 2.6rem;
    }
    @media (max-width: 600px) {
      font-size: 2.2rem;
      line-height: 5.6rem;
    }
  }
`;
